
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"24","fill":"#08C1AB"}}),_c('path',{attrs:{"d":"M33.467 19.667H13.533c-.846 0-1.533.686-1.533 1.533v12.267c0 .846.687 1.533 1.533 1.533h19.934c.846 0 1.533-.687 1.533-1.533V21.2c0-.847-.687-1.533-1.533-1.533zM13.79 15.833H33.21M15.833 12h15.333M15.833 27.844h3.833M15.833 31.422h8.433","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.656 23.244h-3.067a.767.767 0 00-.767.767v3.067c0 .423.344.766.767.766h3.067a.767.767 0 00.766-.766V24.01a.767.767 0 00-.766-.767z","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    